module.exports = __webpack_public_path__ + "static/media/20_000014.74925574.jpg";